import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../api';

export default function BODashboard() {
  const [stands, setStands] = useState([]);

  useEffect(() => {
    api.getStands().then(setStands);
  }, []);

  return (
    <div>
      <h1 className="font-serif text-[#332A1C] text-2xl mb-8">
        Sélectionnez votre stand
      </h1>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {stands.map(stand => (
          <Link
            key={stand.id}
            to={`/backoffice/${stand.id}`}
            className="bg-white border border-[#E2D1B8] rounded-xl p-6 shadow-sm hover:shadow-lg hover:border-[#C4673D] transition-all duration-200 text-center group"
          >
            <h2 className="text-lg font-bold text-[#332A1C] group-hover:text-[#C4673D] transition-colors">{stand.nom}</h2>
            <p className="text-sm text-[#8B7355] mt-1">{stand.type}</p>
            <p className="text-sm text-[#C4673D] mt-3 font-medium">{stand.product_count} produits</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
